import { render } from "./Perkembangan.vue?vue&type=template&id=45d1bfe6"
import script from "./Perkembangan.vue?vue&type=script&lang=js"
export * from "./Perkembangan.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__